<template>
  <div>
    <div style="background: #f8f8f9;width: 100%;padding-left: 20px;padding-top: 5px;padding-bottom: 5px;">
      配电室：<el-select v-model="roomId" placeholder="请选择" style="width: 15%;">
        <el-option v-for="item in roomList" :key="item.id" :label="item.roomName" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div style="padding-left: 18px;padding-right: 18px;height: 100%;">
      <div v-for="(item, index) in datas" :key="index">
        <el-row :gutter="0" class="panel-group"
          style="height: 280px;padding-top: 20px;min-width: 1400px;    display: -webkit-box;">
          <el-col class="card-panel-col" style="width: 350px;white-space: nowrap;">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div>
                  <svg-icon icon-class="bianyaqi3" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  {{item.info.address}}
                </div>
              </div>

              <div class="card-panel-description">
                <div class="card-panel-text-info">
                  电室: {{item.info.room}}
                </div>
                <div class="card-panel-text-info">
                  编号: {{item.info.localNumber}}
                </div>
                <div class="card-panel-text-info" style="    white-space: normal;">
                  描述: {{item.info.desc}}
                </div>
              </div>

            </div>
          </el-col>
          <el-col :span="20" class="card-panel-col" style="height: 100%;width: 1227px;float: left;white-space: nowrap;">
            <el-table border :data="tableData[index]" style="font-size: 11px;">
              <template v-for="(item2, index2) in item.power">
                <el-table-column :key="index2" v-if="index2 < 17" :prop="item2.day" :label="item2.day" width="72"
                  align="center" className="aabbshenmz">
                </el-table-column>
              </template>
            </el-table>
            <el-table border :data="tableData[index]" style="font-size: 11px;">
              <template v-for="(item2, index2) in item.power">
                <el-table-column :key="index2" v-if="index2 >= 17" :prop="item2.day" :label="item2.day" width="72"
                  align="center" className="aabbshenmz">
                </el-table-column>
              </template>
            </el-table>
          </el-col>
        </el-row>

      </div>
    </div>
  </div>
</template>

<script>
  // import layout1 from "../../layout/layout1";
  // import ECharts from "vue-echarts";
  export default {
    name: "bianyaqi",
    data () {
      return {
        projectId: 0,
        datas: [],
        elList: [],
        roomList: [],
        roomId: 0,
        tableData: []
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: {
      // layout1, 
      // "v-chart": ECharts,
    },
    created () {
      this.projectId = this.$getCookie("projectId");
      this.searchEquipmentRoomList()

    },
    mounted () {

    },
    computed: {

    },
    watch: {
      roomId (n) {
        this.searchPeak(n)
      }
    },
    methods: {
      searchPeak (roomId) {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str = strs[0] + "-" + strs[1]
        this.$http
          .post("bma-distribution-service/monthReport/searchHuilu", {
            date: str,
            projectId: this.projectId,
            roomId,
            dateType: this.dateType
          })
          .then((res) => {
            this.datas = res.data.datas

            this.tableData = []
            this.$nextTick(() => {
              this.datas.forEach((data) => {

                let obj = {}
                data.power.forEach((item) => {
                  obj[item.day] = item.value;
                })
                let tempArray = []
                tempArray.push(obj)
                this.tableData.push(tempArray);
              })

            })
          });
      },
      searchEquipmentRoomList () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/equipmentRoom/searchEquipmentRoomListForOverview", {
            projectId: projectId
          }
          )
          .then((res) => {
            if (res.data) {
              this.searchPeak(0);
              this.roomList = res.data;
              let totle = [{ roomName: "全部", id: 0 }]
              this.roomList = totle.concat(this.roomList)

            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;
    background: #fff;



    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }



    .card-panel {
      height: 208px;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      border-color: rgba(0, 0, 0, .05);



      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 54px 0 0 14px;
        width: 100px;
        text-align: center;
        /* padding: 16px; */
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        /* float: left; */
        font-size: 48px;


      }

      .card-panel-description {
        float: left;
        font-weight: bold;
        margin-top: 56px;
        margin-left: 10px;
        text-align: left;
        width: 200px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-text-info {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
</style>